import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { api, getBranchOwner, get } from "@config"
import { AutoComplete } from 'antd';
const { Option } = AutoComplete
import { setLoading } from '@inspinia-react/actions'
import { FormControl } from "react-bootstrap"
import {
    setNcm
} from '../actions'
import { mapTest } from '../../../products/map.test';

function NCM(props) {
    const [result, setResult] = React.useState([])
    const [code, setCode] = React.useState()
    const [input, setInput] = React.useState('')

    const branch = getBranchOwner().id

    function search(e) {
        e = e.replace('.', '').replace('.', '').replace('.', '').replace('-', '').replace('-', '')
        setInput(e)
        if (e.length < 4) return

        const searchBy = isNaN(e) ? "description" : "code";
        const url = `${api.products.ncm}?branch_owner=${branch}&${searchBy}=${e}`;
        const payload = data => {
            setResult(data)
            props.setLoading(false)
        };
        get(url, payload);
    }
    function onSelect(e) {
        props.setNcm(JSON.parse(e))                
    }

    React.useEffect(() => {
        if(props.ncm) {
            setInput(props.ncm.description);
        }
    }, [props.ncm])

    return <React.Fragment>
        <p className="lead mb-1">NCM {props.ncm.code} </p>
        <AutoComplete
            value={input}
            id = {mapTest.createProduct.ncm.input}
            style={{ width: 300 }}
            onSelect={onSelect}
            onSearch={search}
            disabled={props.loading}
            placeholder="Busque pelo nome ou código"
            options={result}
        >
            {
                result.map(item => <Option key={item.id} value={JSON.stringify(item)}>
                    {item.code} | {item.description.substr(0, 100)}
                </Option>)
            }
        </AutoComplete>
        <a title="Consulte a tabela de NCM da SEFAZ" id={mapTest.createProduct.ncm.buttonFindNcm} target="_blank" className="d-block" href="https://cosmos.bluesoft.com.br/ncms">Não sei o NCM</a>
    </React.Fragment>
}

const mapStateToProps = state => ({
    loading: state.loading,
    ncmData: state.ncmData,
    ncm: state.ncm
})
const mapDispatchToProps = dispatch => bindActionCreators({
    setLoading,
    setNcm
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(NCM)


// WEBPACK FOOTER //
// ./src/components/pages/fiscal/taxes/ncm/index.jsx